import React from 'react';

/**
 * This hook returns what the value of the parameter was during the previous
 * render. This is helpful if you need to check if the value changed and only
 * take action if it did.
 *
 * @param value The value to track.
 *
 * @example
 * ```
 * const shouldRefreshProfile = usePrevious(isLoggedIn) !== isLoggedIn;
 * ```
 */
const usePrevious = <T>(value: T): T => {
  const ref = React.useRef(value);

  React.useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
};

export default usePrevious;
